
const getNodeUrl = () => {
  return window.ethereum;
};

export default getNodeUrl;
